import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import "./components/styles/index.scss"
import "@/plugins/clickOutsideDirective";
import VueCookie from 'vue-cookies';
import EventBus from './plugins/EventBus'

Vue.config.productionTip = false
Vue.use(VueCookie)
new Vue({
  store,
  router,
  vuetify,
  render: function (h) { return h(App) }
}).$mount('#app')
